module.exports = __webpack_public_path__ + "static/LucasPope5-bf2893cfced4ccd22b3decfb5e3607b8.webp";